import axios from './axiosService';
import {orderBy} from 'lodash';

/**
 * MLD-3306
 */
export default {
  async getBrand(brandID) {
    return axios.get(`/api/brands/${brandID}`)
      .then(response => response.data);
  },
  async getBrands(params = {}) {
    const options = {
      params,
    }
    return axios.get(`/api/brands`, options)
      .then(response => orderBy(response.data, ['slug'], ['asc']));
  },
  async update(brandID, form) {
    return axios.put(`/api/brands/${brandID}`, form)
      .then(response => response.data);
  },
  async deleteBrand(brandID) { // MLD-4360
    return axios.delete(`/api/brands/${brandID}`)
      .then(response => response.data);
  }
}
